import { createOrder } from "@/api/common"
export default {
	methods: {
		// 点击页面上的批量下载按钮
		handleDownload (item) {
			console.log('item', JSON.parse(JSON.stringify(item)));

			this.queryIsPay(item).then(async data => {
				console.log('queryIsPay', data);
				if (!data) {
					return
				}
				// " 订单状态 status：0：待支付 1：已支付 2：已取消"
				let { orderNo, price, productId, specsId, status } = data
				if (orderNo && status.value == 1) {
					// 下载文件
					this.downloadFile(orderNo, price, item)
				} else {
					console.log(`!([0, '0', '0.00'].includes(price))`, !([0, '0', '0.00'].includes(price)));
					if (!([0, '0', '0.00'].includes(price))) {
						let payDb = {
							avatar: process.env.VUE_APP_BASE_API + 'stage-api' + item.avatar,
							title: item.title,
							nickName: item.nickName,
							number: item.number,
							shrinkId: item.shrinkId,
							indexName: item.indexName,
							// strJson: JSON.parse(item[preIndexTypeLabel]),
							lotteryType: item.preType,
							price, productId, specsId,
						}
						this.$emit('view_download', payDb)
					} else {
						this.$refs.pay.init({ ...item ,...data})
						let resCreateOrder = await this.fun_createOrder(price, item, productId, specsId)
						if (!resCreateOrder) {
							return;
						}
						console.log('resCreateOrder----------------', resCreateOrder);
						// 下载文件
						this.downloadFile(resCreateOrder, price, item)
					}
				}

			}).catch(() => {})

		},

		// 创建订单
		async fun_createOrder (price, item, productId, specsId) {
			let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']

			console.log('item', JSON.parse(JSON.stringify(item)));
			// 创建订单号
			let params = {
				money: price,
				productAuthor: item.shrinkId || item.createUser,	//商家id
				productId,
				productSpecsId: specsId,
				payType: 'balancepay',
				productModel: 0,
				quantity: 1,
				title: `${lotteryType[item.preType * 1]} - ${item.nickName} - ${item.number}`,
				uuid: new Date().getTime(),
			}

			console.log('params----------', params);

			let resCreateOrder = await createOrder(params)
			if (resCreateOrder.code == 500) {
				this.$message.error(resCreateOrder.msg)
				return null;
			}
			console.log('resCreateOrder', resCreateOrder);

			return resCreateOrder.data.orderNo
		},


		// 下载文件
		downloadFile (orderNo, price, item) {
			let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']
			let that = this

			this.$confirm('您确定下载该缩水单吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.get('/stage-api/pre/detail/zipDownload', {
					params: { orderNo, coin: price },
					headers: { 'Authorization': 'Bearer ' + this.vuex_token },
					responseType: 'blob',
					onDownloadProgress: (progressEvent) => {
						const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
						that.$vuex('vuex_downFile_progress', percentCompleted >= 100 ? false : percentCompleted)
					},
				}).then(downRes => {
					if (downRes.code == 500) { return this.$message.error(res.msg) }
					let fileName = `${lotteryType[item.preType * 1]}-${item.number}期-${item.nickName}.zip`
					this.$utils.downloadFile(downRes, fileName, 'application/zip')
				})
			});
		},

		// 查询是否已付款
		queryIsPay (item) {
			/*
				publicationConditions	发布条件
				publicationType		发布类型
				recordId	记录id
			*/
			return new Promise((resolve, reject) => {

				let itemParams = JSON.parse(JSON.stringify(item, ['publicationConditions', 'recordId', 'publicationType']))
				let queryParams = JSON.parse(JSON.stringify(item, ['number', 'preType']))

				this.$http.post('/stage-api/teach/queryDownloadFilePriceByRecordId', {
					...itemParams,
					...queryParams,
					createUser: item.shrinkId || item.createUser,
				}).then(res => {
					if (res && res.code === 401) {
						return reject(res)
					}
					if (!res || res.code !== 200 || !res.data) {
						this.$message.error((res && res.msg) || '查询下载价格失败')
						return reject(res)
					}
					resolve(res.data)
				})

			});
		},
	}
}